var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLongThin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 14,
    viewBox: "0 0 6 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25081 1.88236V13.0986C3.25081 13.3231 3.06888 13.505 2.84446 13.505C2.62003 13.505 2.43811 13.3231 2.43811 13.0986V1.88236L0.693684 3.62678C0.534994 3.78547 0.277707 3.78547 0.119017 3.62678C-0.0396725 3.4681 -0.0396725 3.21081 0.119017 3.05212L2.55712 0.614013C2.71581 0.455323 2.9731 0.455323 3.13179 0.614013L5.5699 3.05212C5.72859 3.21081 5.72859 3.4681 5.5699 3.62678C5.41121 3.78547 5.15392 3.78547 4.99523 3.62678L3.25081 1.88236Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLongThin);
export default __webpack_public_path__ + "static/media/arrow-long-thin.d5d39ab4b84a062de2dac3e58781de04.svg";
export { ForwardRef as ReactComponent };